import React from "react";
import { Row, Col } from "common/components";
import Procedures from "./Procedures";
function ProceduresSegment() {
  return /* @__PURE__ */ React.createElement(Row, { $align: "stretch", $justify: "flex-start", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(Col, { $width: "70%", style: { flexGrow: 1 } }, /* @__PURE__ */ React.createElement(Procedures, null)));
}
export default ProceduresSegment;
